
const MIGRATION_FLAG = "msal_migrated_v2"; 

export function clearLegacyMsalCache() {
  try {
    // If migration already done, skip
    if (localStorage.getItem(MIGRATION_FLAG)) {
      return;
    }

    let cleared = false;

    Object.keys(localStorage).forEach((key) => {
      if (
        key.startsWith("msal.") || // old react-aad-msal tokens
        key.includes("aad.ms") ||  // react-aad-msal internals
        key.includes("adal.")      // legacy ADAL
      ) {
        localStorage.removeItem(key);
        cleared = true;
      }
    });

    if (cleared) {
      console.warn("⚠️ Old MSAL/ADAL cache cleared to prevent redirect loops.");
    }

    // Set migration flag so we don't do this every time
    localStorage.setItem(MIGRATION_FLAG, "true");
  } catch (err) {
    console.error("Error clearing legacy MSAL cache:", err);
  }
}
